// Client twin of utils/customerBranches.js: how a document refers to a customer's branch.
// A document has `clientBranch` (id in customer.branches) and `billTo` ("branch" | "head_office");
// a sent invoice also has `branchSnapshot` (the branch as it was issued).

export const sameId = (a, b) => Boolean(a && b) && String(a?._id || a) === String(b?._id || b);

export const findBranch = (customer, branchId) =>
  (customer?.branches || []).find(b => sameId(b._id, branchId)) || null;

/** The branch of a (populated) document, preferring the copy frozen when it was sent. */
export const branchOfDoc = doc => {
  if (!doc?.clientBranch) return null;
  if (doc.branchSnapshot?.name) return doc.branchSnapshot;
  return findBranch(doc.client, doc.clientBranch);
};

/** "Filiale Köln (012)" */
export const branchLabel = branch =>
  branch ? `${branch.name}${branch.code ? ` (${branch.code})` : ""}` : "";

/** "Domplatz 5, 50667 Köln" */
export const branchAddress = branch =>
  [branch?.address, [branch?.zipCode, branch?.city].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");

/** Customer name for lists: "Markt AG · Filiale Köln (012)" */
export const customerWithBranch = doc => {
  const c = doc?.client;
  const name = c ? c.company || [c.firstName, c.lastName].filter(Boolean).join(" ") : "";
  const branch = branchOfDoc(doc);
  return branch ? `${name} · ${branchLabel(branch)}` : name;
};

/** Branches that can be picked for a document (archived ones only if already chosen). */
export const pickableBranches = (customer, currentId) =>
  (customer?.branches || []).filter(b => b.active !== false || sameId(b._id, currentId));
